import { render, staticRenderFns } from "./legal-home.vue?vue&type=template&id=2018cf61&scoped=true&"
import script from "./legal-home.vue?vue&type=script&lang=js&"
export * from "./legal-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2018cf61",
  null
  
)

export default component.exports